import { Injectable } from '@angular/core';
import { SvgExportService } from './svg-export.service';
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
declare function unescape(s: string): string;

@Injectable()
export class PngExportService {
  constructor(private svgExportService: SvgExportService) {}

  private svgString2Image(
    svgString,
    b64String,
    width,
    height,
    paddingLeft,
    paddingTop,
    format,
    svgZoomLevel = 1,
    callback
  ) {
    format = format ? format : 'png';

    let data;
    if (svgString) {
      data = 'data:image/svg+xml,' + encodeURIComponent(svgString); // Convert SVG string to dataurl
    }
    if (b64String) {
      data = 'data:image/svg+xml;base64,' + b64String;
    }

    const canvas = document.createElement('canvas');

    const context: any = canvas.getContext('2d');

    canvas.width = width * svgZoomLevel;
    canvas.height = height * svgZoomLevel;

    // finally query the various pixel ratios
    const devicePixelRatio = 2;

    const backingStoreRatio =
      context.webkitBackingStorePixelRatio ||
      context.mozBackingStorePixelRatio ||
      context.msBackingStorePixelRatio ||
      context.oBackingStorePixelRatio ||
      context.backingStorePixelRatio ||
      1;

    const ratio = devicePixelRatio / backingStoreRatio;

    // upscale the canvas if the two ratios don't match
    if (devicePixelRatio !== backingStoreRatio) {
      const oldWidth = canvas.width;
      const oldHeight = canvas.height;

      canvas.width = oldWidth * ratio;
      canvas.height = oldHeight * ratio;

      canvas.style.width = oldWidth + 'px';
      canvas.style.height = oldHeight + 'px';

      if (b64String) {
        width = width * ratio;
        height = height * ratio;
      }

      // now scale the context to counter
      // the fact that we've manually scaled
      // our canvas element
      context.scale(ratio, ratio);
    }

    const image = new Image();
    image.onload = function() {
      context.clearRect(0, 0, width, height);
      context.drawImage(image, paddingLeft, paddingTop, width, height);

      canvas.toBlob(function(blob: any) {
        const filesize = Math.round(blob.length / 1024) + ' KB';
        if (callback) {
          callback(blob, filesize);
        }
      });
    };

    image.src = data;
  }

  public saveCanvas(canvasId, filename) {
    const canvas = document.getElementById(canvasId);

    (canvas as any).toBlob(function(blob: any) {
      saveAs(blob, filename + '.png');
    });
  }

  public createCanvas(svgId, filename = null, svgZoom = 1) {
    const svg: any = document.getElementById(svgId);
    const paddingLeft = parseInt(document.defaultView.getComputedStyle(svg, '').getPropertyValue('padding-left'), 10);
    const paddingTop = parseInt(document.defaultView.getComputedStyle(svg, '').getPropertyValue('padding-top'), 10);

    const width = svg.clientWidth;
    const height = svg.clientHeight;

    let domString = this.svgExportService.publicAddStyle(svg);

    // let data = new XMLSerializer().serializeToString(oDOM);
    domString = domString.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace
    domString = domString.replace(/NS\d+:href/g, 'xlink:href'); // Safari NS namespace fix
    domString = domString.replace(/<!--[\s\S]*?-->/g, ''); // remove comments

    // add xml declaration
    domString = '<?xml version="1.0" standalone="no"?>\r\n' + domString;

    // make it base64
    const svg64 = window.btoa(unescape(encodeURIComponent(domString)));

    this.svgString2Image(null, svg64, width, height, paddingLeft, paddingTop, '.png', svgZoom, function(blob, s) {
      if (filename) {
        saveAs(blob, filename + '.png');
      }
    });
  }

  public save(elemId, filename = null) {
    if (!filename) {
      filename = elemId;
    }

    const domElement = document.getElementById(elemId);
    const domW = domElement.clientWidth;
    const domH = domElement.clientHeight;
    let domString: string;
    if (domElement.tagName.toLowerCase() !== 'svg') {
      domString = this.svgExportService.wrapElementInSVG(domElement, domW, domH);
    } else {
      domString = this.svgExportService.publicAddStyle(domElement);
    }

    this.svgString2Image(domString, null, domW, domH, 0, 0, 'png', 1, function(blob, s) {
      saveAs(blob, filename + '.png');
    });

    // if (this.idtosave === 'graph') {
    //   let f = svg.getAttribute('filename');
    //   this.svgString2Image(svgString, 2 * svg.width.baseVal.value, 2 * svg.height.baseVal.value, 'png', function(blob, s) {
    //     FileSaver.saveAs(blob, 'graph_' + f + '.png');
    //   });

    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/png-export.service.ts